import React, { Component } from 'react';
import _ from 'underscore';
import { ButtonGroup } from 'react-bootstrap';
import { mixinsClassName, activeItems } from '../../utils';

export default class extends Component {
    onClick(item, ev) {
        const self = this;
        const { onClick, data } = this.props;

        let id = _.isObject(item) ? item.id : item;
        item = _.find(data, { id: id });

        if (onClick) {
            onClick(item.id, {
                execActive() {
                    activeItems(data, item);
                    self.forceUpdate();
                }
            });
        } else {
            activeItems(data, item);
            self.forceUpdate();
        }
    }

    render() {
        const { itemClassName = '', data = [] } = this.props;
        const className = mixinsClassName("ui-tab", this.props);

        return (
            <ButtonGroup justified className={className}>
              {
                data.map((item)=>{
                  return (<a key={item.id} className={mixinsClassName(itemClassName, item.clz, item.active ? "active" : "")} onClick={this.onClick.bind(this, item)}></a>)
                })
              }
            </ButtonGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/tab/index.js